import { Divider } from "@mui/material";

import ProviderField from "./ProviderField";

export default function ProviderSummary({ data }) {
  const notes = data?.notes ?? null;
  if (!notes) {
    return;
  }

  return (
    <div className="flex flex-col gap-4">
      <Divider />
      <div className="p-2">
        <ProviderField label="Provider Summary" data={notes} />
      </div>
    </div>
  );
}
